import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-col brand-col">
            <div className="footer-logo">Resumify</div>
            <p className="footer-desc">
              The intelligent AI-powered resume builder designed to bypass ATS
              filters and land you more interviews.
            </p>
            <div className="footer-socials">
              <span className="social-badge">🇬🇧 UK Engineered</span>
              <span className="social-badge">🔒 Secure & Encrypted</span>
            </div>
          </div>

          {/* Product Links */}
          <div className="footer-col">
            <h4>Product</h4>
            <ul>
              <li>
                <Link to="/builder">Builder</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
              <li>
                <Link to="/contactus">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Legal / Policies */}
          <div className="footer-col">
            <h4>Legal & Trust</h4>
            <ul>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/security">Data Security</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Resumify.co.uk. All rights
            reserved.
          </p>
          <p className="footer-subtext">Built for modern job seekers.</p>
        </div>
      </div>
    </footer>
  );
}
